/* eslint-disable class-methods-use-this */
/* eslint-disable no-underscore-dangle */
import format from 'date-fns/format';

import Model from './Model';
import Coach from './Coach';

export default class Customer extends Model {
    // noinspection JSMethodCanBeStatic
    resource() {
        return 'customers';
    }

    static getAdminList() {
        return Customer.get();
    }

    get readableWebsite() {
        return this.website.replace(/^https?:\/\/([^/]+).*$/, '$1');
    }

    get readableCreatedAt() {
        return format(this.createdAt, 'DD.MM.YYYY');
    }

    async getCoach() {
        return new Coach(this.coach);
    }
}
